import React from 'react';
import cl from "./PrepodsList.module.css";
import PrepodsListCase from "./PrepodsListCase/PrepodsListCase";
import { Teacher } from '../../../api/api'; // Импортируем из api.ts

interface PrepodsListProps {
    prepods: Teacher[];
}

const PrepodsList: React.FC<PrepodsListProps> = ({ prepods }) => {
    return (
        <div className={cl.eruditTeachersGrid}>
            {prepods.map((prepod) => (
                <PrepodsListCase prepod={prepod} key={prepod.id}/>
            ))}
        </div>
    );
};

export default PrepodsList;